import { useEffect, useState, type ReactNode } from 'react'
import { ChevronDown } from 'lucide-react'
import { cn } from '../../styles/design-tokens'

export interface WorkflowSectionProps {
  title: string
  description?: string
  summary?: ReactNode
  children: ReactNode
  collapsible?: boolean
  defaultOpen?: boolean
  attention?: boolean
  className?: string
}

/** A task section: keeps a short summary visible while preserving full controls. */
export function WorkflowSection({ title, description, summary, children, collapsible = false, defaultOpen = false, attention = false, className }: WorkflowSectionProps) {
  const [open, setOpen] = useState(defaultOpen)
  useEffect(() => { if (attention) setOpen(true) }, [attention])
  const heading = <><span className="min-w-0 flex-1"><span className="block text-sm font-semibold text-gray-900 dark:text-zinc-100">{title}</span>{description && <span className="mt-1 block text-xs font-normal text-gray-500 dark:text-zinc-400">{description}</span>}{summary && <span className="mt-2 block text-xs font-normal text-indigo-700 dark:text-indigo-300">{summary}</span>}</span>{attention && <span className="text-xs text-amber-700 dark:text-amber-300">Требует внимания</span>}</>
  return <section className={cn('min-w-0 rounded-lg border border-gray-200 bg-white dark:border-zinc-800 dark:bg-zinc-900', className)}>
    {collapsible ? <button type="button" aria-expanded={open} onClick={() => setOpen(value => !value)} className="flex w-full items-start gap-3 p-4 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500">{heading}<ChevronDown aria-hidden="true" className={cn('mt-0.5 h-4 w-4 shrink-0 transition-transform', open && 'rotate-180')} /></button> : <div className="flex items-start gap-3 p-4">{heading}</div>}
    <div hidden={collapsible && !open} className="min-w-0 border-t border-gray-100 p-4 dark:border-zinc-800">{children}</div>
  </section>
}
